<template>
    <v-window v-model="TabsTertiaryValue" v-bind="$attrs" @change="TabsTertiaryValueChange">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-window>
</template>

<script>
export default {
    props: {
        value: { type: [Number, String] },
    },
    components: {},
    data() {
        return {};
    },
    computed: {
        TabsTertiaryValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },
    mounted() {},
    methods: {
        TabsTertiaryValueChange(newValue) {
            this.TabsTertiaryValue = newValue;
        },
    },
};
</script>

<style lang="scss" scoped></style>
